<script>
import { mapActions, mapState } from "vuex";

export default {
  methods: {
    ...mapActions("orderScheduler", ["cancelOrderOffer"])
  },

  computed: {
    ...mapState("orderScheduler", ["orderOfferExpired"])
  }
};
</script>

<template>
  <div class="empty">
    <img src="/static/radar.gif" />

    <template v-if="!orderOfferExpired">
      <p class="info-header">Lista vazia.</p>

      <p class="info">
        Aguarde um pouco que estamos notificando profissionais perto de você...
      </p>
    </template>

    <template v-else>
      <p class="info-header">Não encontramos profissionais disponíveis para realizar a limpeza no dia, hora e duração informado.</p>

      <p class="info">
        Você pode alterar os filtros ou tentar novamente dentro de alguns instantes.
      </p>

      <button
        class="btn btn-pink order-offer"
        @click="cancelOrderOffer"
      >
        <span>voltar</span>
      </button>
    </template>
  </div>
</template>

<style scoped>
.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: #424242;
}

img {
  width: 60px;
  filter: invert(23%) sepia(0%) saturate(1094%) hue-rotate(176deg)
    brightness(100%) contrast(90%);
}

.info-header {
  margin-bottom: 0;
  font-weight: 400;
}

.info {
  font-size: 14px;
  font-weight: 300;
}

.order-offer {
  width: 100%;
  height: 40px;
  margin: 16px 0px;
  display: flex;
  font-weight: 400;
  justify-content: center;
  align-items: center;
  color: #fff;
  background: #af006b;
  border-radius: 2px;
  font-size: 14px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalOfferList/Empty.vue